import classNames from 'classnames';
import * as React from 'react';
import { INavigation } from 'redux-state/layout/types.layout.base.js';

export const FiveUpPrimaryGridClasses = ({
  navData,
  children,
}: {
  navData: INavigation | undefined;
  children: JSX.Element;
}) => {
  const hasNavigation = Boolean(navData?.links?.length);

  const gridClasses = React.useMemo(
    () => classNames('Grid Grid--withGutter', { 'u-pB-responsive': hasNavigation }),
    [hasNavigation],
  );

  return <div className={gridClasses}>{children}</div>;
};
